import TemplateContents from './TemplateContents';
import BicCarousel from "./BicCarousel";

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();
    this.carousel = new BicCarousel();
    this.carousel.setOnlyPC();
    this.carousel.setTarget(this.sectionDom, this.sectionDom);

    // スライド連動用の変数初期化
    this.globalMouse = { x: this.sw / 2, y: this.sh / 2 }; // 画面全体のマウス位置
    this.globalMouseMoveHandler = (e) => {
      this.globalMouse.x = e.clientX;
      this.globalMouse.y = e.clientY;
    };

    this.prevTrackX = 0;
    this.isFirstFrame = true;
    this.itemsState = new Map(); // 各アイテムの座標やDOMを管理

    if(this.itemAll){
      this.itemAll.forEach(item => {
        const inner = item.querySelector('.item_inner');
        const front = item.querySelector('.front');
        const back = item.querySelector('.back');

        this.itemsState.set(item, {
          mouseX: 0,       // マウスの目標X位置
          mouseY: 0,       // マウスの目標Y位置
          currentMouseX: 0, // 現在のX位置（イージング用）
          currentMouseY: 0, // 現在のY位置（イージング用）
          inner: inner,    // DOMキャッシュ
          front: front,    // DOMキャッシュ
          back: back,      // DOMキャッシュ
          currentTiltOffset: 0 // Z軸押し出し量のイージング用
        });
      });
    }
  }

  reset() {
    super.reset();
    this.setVars();
  }

  destruct() {
    super.destruct();
    if (this.observer) this.observer.disconnect();
    window.removeEventListener('mousemove', this.globalMouseMoveHandler);
  }

  setVars() {
    super.setVars();
    this.mouseTiltFactor = 0.03;
  }

  setDom() {
    super.setDom();

    this.sectionDom = document.querySelector('main.top .section3');
    this.track = this.sectionDom.querySelector('ul');
    this.itemAll = this.sectionDom.querySelectorAll('ul .item');
    this.arrow = this.sectionDom.querySelector('.arrow');
    this.moreBtn = document.querySelector('main.top .section3 .btn button');
    this.prevBtn = document.querySelector('main.top .section3 .ui .prev_bt');
    this.nextBtn = document.querySelector('main.top .section3 .ui .next_bt');
  }

  initEvents() {
    super.initEvents();

    this.pack.applyIconHoverEffect(this.prevBtn, this.prevBtn);
    this.pack.applyIconHoverEffect(this.nextBtn, this.nextBtn);

    this.prevBtn.addEventListener('mousedown', ()=>{
      this.pack.commonClick(this.prevBtn);
    });

    this.prevBtn.addEventListener('touchstart', ()=>{
      this.pack.commonClick(this.prevBtn);
    });

    this.nextBtn.addEventListener('mousedown', ()=>{
      this.pack.commonClick(this.nextBtn);
    });

    this.nextBtn.addEventListener('touchstart', ()=>{
      this.pack.commonClick(this.nextBtn);
    });

    // 画面内に入った時だけmousemoveを監視する
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) window.addEventListener('mousemove', this.globalMouseMoveHandler);
        else window.removeEventListener('mousemove', this.globalMouseMoveHandler);
      });
    }, options);

    if (this.sectionDom) this.observer.observe(this.sectionDom);

    if(this.itemAll){
      this.itemAll.forEach((item) => {
        item.addEventListener('mousemove', (e) => {
          const rect = e.currentTarget.getBoundingClientRect();
          const state = this.itemsState.get(item);
          if (state) {
            state.mouseX = e.clientX - rect.left - (rect.width / 2);
            state.mouseY = e.clientY - rect.top - (rect.height / 2);
          }
        });

        item.addEventListener('mouseleave', () => {
          const state = this.itemsState.get(item);
          if (state) {
            state.mouseX = 0;
            state.mouseY = 0;
          }
        });

        item.addEventListener('mouseenter', () => {
          if(this.arrow) this.arrow.classList.add('show');
        });
        item.addEventListener('mouseleave', () => {
          if(this.arrow) this.arrow.classList.remove('show');
        });
      });
    }

    // もっと見るボタンの処理
    if (this.moreBtn) {
      this.moreBtn.addEventListener('click', () => {
        if (this.track) this.track.classList.add('show_all');
        // ボタンの親要素(.btn)をアイテム展開と同じ速度でフェードアウトさせる
        if (this.moreBtn.parentNode) this.moreBtn.parentNode.classList.add('is-hide');
      });
    }
  }

  start() {}

  scrollHandler() {}

  enterframe() {
    if(this.pack.hasTouch) return;
    if (!this.track) return;

    // 1. カルーセルの移動速度を計算
    const currentTrackX = this.track.getBoundingClientRect().left;
    
    if (this.isFirstFrame) {
      this.prevTrackX = currentTrackX;
      this.isFirstFrame = false;
    }

    const diff = currentTrackX - this.prevTrackX;
    this.prevTrackX = currentTrackX;

    // 更新が必要かどうかのフラグ（カルーセルが動いているか？）
    let shouldUpdate = Math.abs(diff) > 0.01;

    // 2. 各アイテムのイージング計算と更新判定
    this.itemsState.forEach((state) => {
      const diffX = state.mouseX - state.currentMouseX;
      const diffY = state.mouseY - state.currentMouseY;

      // まだ目標値に到達していなければ更新が必要
      if (Math.abs(diffX) > 0.01 || Math.abs(diffY) > 0.01 || Math.abs(state.currentTiltOffset) > 0.01) {
        shouldUpdate = true;
      }

      // イージング処理（現在値 += (目標値 - 現在値) * 減衰率）
      state.currentMouseX += diffX * 0.1;
      state.currentMouseY += diffY * 0.1;
    });

    // 動きがなければDOM操作をスキップ（負荷軽減）
    if (!shouldUpdate) return;

    // 速度に応じた傾き
    const slideTilt = diff * 0.5;

    // 3. DOMに適用
    this.itemsState.forEach((state, item) => {
      const x = state.currentMouseX;
      const y = state.currentMouseY;

      const rect = item.getBoundingClientRect();
      const itemCenterX = rect.left + rect.width / 2;
      const distFromMouse = Math.abs(this.globalMouse.x - itemCenterX);
      
      let proximityScale = 1 - (distFromMouse / (this.sw * 0.8));
      if (proximityScale < 0.3) proximityScale = 0.3;

      const localSlideTilt = slideTilt * proximityScale;

      // 回転差によるめり込みを防ぐため、傾きに応じてZ軸を押し出す
      // 幅広のアイテムなので、回転差がつくと端が干渉しやすい
      // const tiltOffset = Math.abs(localSlideTilt) * 0.3;
      // イージングを追加してピクつきを抑える
      const targetTiltOffset = Math.abs(localSlideTilt) * 0.6;
      state.currentTiltOffset += (targetTiltOffset - state.currentTiltOffset) * 0.1;

      const dist = Math.abs(x) + Math.abs(y);
      // マウス距離による浮き出し + 傾きによる浮き出し(tiltOffset)
      const moveZ_Front = (dist * 0.25) / 10 + state.currentTiltOffset;
      const moveZ_Back = (dist * 0.3) / 10;

      // マウス位置による回転 + スライド速度による回転(localSlideTilt)を合成
      const rotateX_Front = -y * this.mouseTiltFactor;
      const rotateY_Front = x * this.mouseTiltFactor + localSlideTilt * 0.7;

      const rotateX_Back = -y * this.mouseTiltFactor;
      const rotateY_Back = x * this.mouseTiltFactor + localSlideTilt * 0.5;

      const rotateX_Item = -y * this.mouseTiltFactor;
      const rotateY_Item = x * this.mouseTiltFactor + localSlideTilt * 0.25;

      if(state.front) state.front.style.transform = `translate3d(0, 0, ${moveZ_Front}rem) rotateX(${rotateX_Front}deg) rotateY(${rotateY_Front}deg)`;
      if(state.back) state.back.style.transform = `translate3d(0, 0, -${moveZ_Back}rem) rotateX(${rotateX_Back}deg) rotateY(${rotateY_Back}deg)`;
      if(state.inner) state.inner.style.transform = `rotateX(${rotateX_Item}deg) rotateY(${rotateY_Item}deg)`;
    });

    // 矢印の追従処理
    if (this.arrow && this.arrow.classList.contains('show')) {
      const rect = this.sectionDom.getBoundingClientRect();
      const x = this.globalMouse.x - rect.left;
      const y = this.globalMouse.y - rect.top;
      this.arrow.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    }
  }

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();
    if(this.carousel) this.carousel.resetToInitialPosition();
  }
}
